import Anchor from '@/components/shared/Anchor'
import Checkbox from '@/components/form/Checkbox'
import styles from './styles.module.css'

const Terms = ({state, onTermsClick, onCheckboxChange}) => {
  return (
    <div className={styles.termsLabel}>
      <Checkbox
        name="terms"
        checked={state.terms}
        onChange={onCheckboxChange}
      />
      Li e aceito os{'   '}
      <Anchor onClick={onTermsClick}>termos de uso*</Anchor>
    </div>
  )
}

export default Terms
